import React from 'react';
import './ContactPage.scss';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="container">
        <h1 className="contact-page__title">Contact Us</h1>
        
        <div className="contact-page__wrapper">
          {/* Left Section - Contact Information */}
          <div className="contact-page__info">
            {/* Vasudha Foundation */}
            <div className="contact-card">
              <h2 className="contact-card__title">Vasudha Foundation</h2>
              <div className="contact-card__item">
                <img src="/images/contact-us/location.png" alt="Location" className="contact-card__icon" />
                <span className="contact-card__text">
                  2850 Field Line Dr, Sugar Land, TX 77479, USA
                </span>
              </div>
              {/* <div className="contact-card__item">
                <img src="/images/contact-us/phone.png" alt="Phone" className="contact-card__icon" />
                <span className="contact-card__text">11-2437-3680</span>
              </div> */}
              <div className="contact-card__item">
                <img src="/images/contact-us/web-link.png" alt="Website" className="contact-card__icon" />
                <a href="https://vasudhausa.org/" target="_blank" rel="noopener noreferrer" className="contact-card__link">
                vasudhausa.org
                </a>
              </div>
            </div>
            <div className="contact-card">
              <h2 className="contact-card__title">ACCESS Coalition</h2>
              <div className="contact-card__item">
                <img src="/images/contact-us/location.png" alt="Location" className="contact-card__icon" />
                <span className="contact-card__text">
                  PR2H+JX7, Dunga Rd, Nairobi, Kenya
                </span>
              </div>
              <div className="contact-card__item">
                <img src="/images/contact-us/phone.png" alt="Phone" className="contact-card__icon" />
                <span className="contact-card__text">+254 791 345194</span>
              </div>
              <div className="contact-card__item">
                <img src="/images/contact-us/web-link.png" alt="Website" className="contact-card__icon" />
                <a href="https://access-coalition.org/" target="_blank" rel="noopener noreferrer" className="contact-card__link">
                access-coalition.org
                </a>
              </div>
            </div>

            <div className="contact-card">
              <h2 className="contact-card__title">STEER - Centre for Sustainable Transitions: Energy, Environment and Resilience</h2>
              <div className="contact-card__item">
                <img src="/images/contact-us/location.png" alt="Location" className="contact-card__icon" />
                <span className="contact-card__text">
                  Epinal Way, Loughborough, Leicestershire LE11 3TU, UK
                </span>
              </div>
              <div className="contact-card__item">
                <img src="/images/contact-us/phone.png" alt="Phone" className="contact-card__icon" />
                <span className="contact-card__text">+44 (0)1509 222222</span>
              </div>
              <div className="contact-card__item">
                <img src="/images/contact-us/web-link.png" alt="Website" className="contact-card__icon" />
                <a href="https://www.lboro.ac.uk/research/steer/" target="_blank" rel="noopener noreferrer" className="contact-card__link">
                www.lboro.ac.uk/research/steer/
                </a>
              </div>
            </div>
          </div>

          {/* Right Section - Map */}
          <div className="contact-page__map">
            <iframe
              src="https://www.google.com/maps?q=2850+Field+Line+Dr,+Sugar+Land,+TX+77479,+USA|PR2H%2BJX7,+Dunga+Rd,+Nairobi,+Kenya|Epinal+Way,+Loughborough,+Leicestershire+LE11+3TU,+UK&hl=en&z=2&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Partner Locations Map - Vasudha Foundation, ACCESS Coalition, and STEER"
            ></iframe>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="contact-page__footer">
          <p>
            For any enquires or feedback reach out to{' '}
            <a href="mailto:info@vasudhausa.org" className="contact-page__email">
              info[at]vasudhausa[dot]org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;



